import { createStore } from "../../../../../../../reactive/store.js";
export const pendingTransactions = /* @__PURE__ */ createStore([]);
/**
 * @internal
 */
export const addPendingTx = (txInfo) => {
    const currentValue = pendingTransactions.getValue();
    // prepend the new tx to list
    pendingTransactions.setValue([txInfo, ...currentValue]);
};
//# sourceMappingURL=pendingSwapTx.js.map